export const events: Record<string, string> = {
  // views
  BM_PAGE_VIEWED: 'brand_management_displayed',
  BM_EDIT_PAGE_VIEWED: 'brand_management_edit_displayed',
  BM_CREATE_PAGE_VIEWED: 'brand_management_create_displayed',
  BM_PREVIEW_PAGE_VIEWED: 'brand_management_preview_displayed',
  BM_REPORT_PAGE_VIEWED: 'brand_management_report_displayed',

  // pages
  EDIT_BRAND: 'edit brand',
  BRAND_MANAGEMENT: 'brand management',
  CREATE_BRAND: 'create brand',
  PREVIEW_BRAND: 'brand preview',
  BRAND_REPORT: 'brand report',

  // links
  BRAND_NAME_CLICKED: 'brand_name_pressed',
  BRANDING_GUIDELINES_INTERACTED: 'branding_guidelines_pressed',
  CANVA_BUTTON_INTERACTED: 'design_on_canva_pressed',
  LEGACY_LOGOS_CLICKED: 'legacy-logos-link-clicked',

  // links - logos
  LOGO_ADD_CLICKED: 'add_logo_pressed',
  LOGO_REPLACE_CLICKED: 'replace_logo_pressed',
  LOGO_UPLOAD_CLICKED: 'upload_logo_pressed',
  LOGO_UPLOADED: 'upload_logo_succeeded',
  LOGO_SELECTED: 'logo_pressed',
  LOGO_ASSET_DELETE_CLICKED: 'delete_logo_icon_pressed',
  LOGO_ASSET_DELETE_CONFIRM_CLICKED: 'delete_logo_confirm_pressed',
  LOGO_ASSET_DELETE_CANCEL_CLICKED: 'cancel_delete_logo_confirm_pressed',

  // links - cover
  COVER_IMAGE_ADD_CLICKED: 'add_cover_image_pressed',
  COVER_IMAGE_SAVE_CROP_CLICKED: 'save_cover_image_pressed',
  COVER_IMAGE_UPLOAD_CLICKED: 'upload_cover_image_pressed',
  COVER_IMAGE_UPLOADED: 'upload_cover_image_succeeded',
  COVER_IMAGE_SELECTED: 'cover_image_pressed',
  COVER_IMAGE_REMOVE_CLICKED: 'remove_cover_image_pressed',
  COVER_IMAGE_EDIT_CLICKED: 'edit_cover_image_pressed',
  COVER_IMAGE_REPOSITION_CLICKED: 'edit_cover_image_pressed',
  COVER_IMAGE_REPLACE_CLICKED: 'replace_cover_image_pressed',
  COVER_ASSET_DELETE_CLICKED: 'delete_cover_icon_pressed',
  COVER_ASSET_DELETE_CONFIRM_CLICKED: 'delete_cover_confirm_pressed',
  COVER_ASSET_DELETE_CANCEL_CLICKED: 'cancel_delete_cover_confirm_pressed',

  // brand edit/create action buttons
  CREATE_BRAND_SAVE_CLICKED: 'create_brand_save_pressed',
  CREATE_BRAND_CANCEL_CLICKED: 'create_brand_cancel_pressed',
  EDIT_BRAND_SAVE_CLICKED: 'edit_brand_save_pressed',
  EDIT_BRAND_CANCEL_CLICKED: 'edit_brand_cancel_pressed',

  // Home page
  CREATE_NEW_BRAND_CLICKED: 'create_new_brand_pressed',
  EDIT_BRAND_CLICKED: 'edit_brand_pressed',
  PREVIEW_BRAND_CLICKED: 'preview_brand_pressed',
  SET_DEFAULT_BRAND_CLICKED: 'set_default_brand_pressed',
  CLEAR_DEFAULT_BRAND_CLICKED: 'clear_default_brand_pressed',
  DELETE_BRAND_CLICKED: 'delete_brand_pressed',
  DELETE_BRAND_CONFIRMATION_CLICKED: 'delete_brand_confirm_pressed',
  LOGO_DELETED: 'logo-deleted',
  BRANDS_SEARCHED: 'brand_search_pressed',
  VIEW_ALL_BRANDS_CLICKED: 'view_all_brands_pressed',

  // brand report page
  DOWNLOAD_BUTTON_CLICKED: 'download_pressed',

  // header & footer
  GLOBAL_HEADER: 'global-header',
  GLOBAL_FOOTER: 'global-footer',
};
